const FEATURE_HELP_URLS = {
  agent_bots: '/ajuda/ia',
  agents: '/ajuda/equipe',
  audit_logs: '/ajuda/seguranca',
  campaigns: '/ajuda/campanhas',
  canned_responses: '/ajuda/inbox',
  channel_email: '/ajuda/canais',
  channel_facebook: '/ajuda/canais',
  custom_attributes: '/ajuda/contatos',
  dashboard_apps: '/ajuda/integracoes',
  help_center: '/ajuda/central-de-ajuda',
  inboxes: '/ajuda/canais',
  integrations: '/ajuda/integracoes',
  labels: '/ajuda/inbox',
  macros: '/ajuda/automacoes',
  reports: '/ajuda/relatorios',
  sla: '/ajuda/automacoes',
  team_management: '/ajuda/equipe',
  webhook: '/ajuda/api',
  whatsapp_templates: '/ajuda/canais',
  saml: '/ajuda/seguranca',
  captain: '/ajuda/ia',
  captain_billing: '/ajuda/ia',
  shopify: '/ajuda/integracoes',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
